import * as constants from '@/common/constants';
import { get, post, put, del } from '@/utils/http';

/** 获取模型列表 */
export const getModelServiceList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_APPLICATION_MODEL_LIST, params);
};

export const saveModelService = (processInfo) => {
    return post(constants.API_APPLICATION_MODEL_SAVE, processInfo);
};

export const saveModelServiceSortOrder = (ids) => {
    return put(constants.API_APPLICATION_MODEL_SORT_SAVE, ids);
};

export const publishModelService = (modelId) => {
    return post(constants.API_APPLICATION_MODEL_PUBLISH.replace(':modelId', modelId));
};

export const bathPublishModelService = (appId) => {
    return post(constants.API_APPLICATION_MODEL_BATH_PUBLISH.replace(':appId', appId));
};

export const publishApplication = (params = {}) => {
    return post(constants.API_APPLICATION_PUBLISH, params);
};
export const queyApplicationGrantAuthorizationUsers = (params = {}) => {
    return post(constants.API_QUEY_APPLICATION_GRANTAUTHORIZATION_USERS, params);
};
export const unpublishApplication = (params = {}) => {
    return post(constants.API_APPLICATION_UNPUBLISH, params);
};

export const copyCustomFormById = (params = {}) => {
    return post(constants.API_COPY_CUSTOMBYID, params);
};

export const transferCustomFormById = (params = {}) => {
    return post(constants.API_TRANSFER_CUSTOMBYID, params);
};

export const deleteModelService = (formId) => {
    return del(`${constants.API_FORM_TEMPLATE_DELETE}/${formId}`);
};
export const getPublishedApplicationList = (params = {}) => {
    return get(constants.API_PUBLISHED_APPLICATION_LIST, params);
};
export const getPublishedApplicationParentList = (params = {}) => {
    return get(constants.API_PUBLISHEDAPPLICATIONPARENTLIST, params);
};
export const getPublishedModelbyAppIdList = (appId) => {
    return get(constants.API_PUBLISHED_MODELBYAPPID_LIST, { appId });
};

/** 获取表单详情 */
export const getModelFormById = (modelId) => {
    return new Promise((resolve, reject) => {
        get(constants.API_APPLICATION_MODEL_FORM_DETAIL.replace(':modelId', modelId)).then(res => {
            try {
                if (res.formObj) {
                    res.formObj.structure.forEach((item1, index1) => {
                        item1.fieldsList.forEach((item2, index2) => {
                            res.formObj.structure[index1].fieldsList[index2].formField = item2.id;
                        });
                    });
                }
            } catch (error) {
                reject(error);
            }
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};

export const getModelFormByDraft = (param) => {
    return post(constants.API_APPLICATION_MODEL_FORM_GET_MODEL_FORM_BY_DRAFT, param);
};

/** 获取表单详情 */
export const getModelFormHistoryById = (modelId) => {
    return new Promise((resolve, reject) => {
        get(constants.API_APPLICATION_MODEL_FORM_DETAIL_HISTORY.replace(':modelId', modelId)).then(res => {
            try {
                if (res.formObj) {
                    res.formObj.structure.forEach((item1, index1) => {
                        item1.fieldsList.forEach((item2, index2) => {
                            res.formObj.structure[index1].fieldsList[index2].formField = item2.id;
                        });
                    });
                }
            } catch (error) {
                reject(error);
            }
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};
/** 获取表单实例详情 */
export const getModelFormInstanceById = (instanceId) => {
    return new Promise((resolve, reject) => {
        get(constants.API_APPLICATION_MODEL_FORM_INSTANCE_DETAIL.replace(':instanceId', instanceId)).then(res => {
            try {
                if (res && res.formObj) {
                    res.formObj.structure.forEach((item1, index1) => {
                        item1.fieldsList.forEach((item2, index2) => {
                            res.formObj.structure[index1].fieldsList[index2].formField = item2.id;
                        });
                    });
                }
            } catch (error) {
                reject(error);
            }
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};

/** 获取表单实例详情 */
export const getModelFormInstanceByIdToLink = (param) => {
    return get(constants.API_APPLICATION_MODEL_FORM_INSTANCE_DETAIL_TO_LIKN, param);
};

/** 根据id获取表单实例数据流程详细信息 */
export const getModeInstanceProcessDetail = (param) => {
    return get(constants.API_APPLICATION_MODEL_FORM_INSTANCE_PROCESS_DETAIL, param);
};

export const saveAppModelForm = (modelId, modelInfo) => {
    return post(constants.API_SAVE_APPLICATION_MODEL_FORM.replace(':modelId', modelId), modelInfo);
};
export const checkDataLegitimacy = (paramInfo) => {
    return post(constants.API_SAVE_APPLICATION_CHECKDATALEGITIMACY, paramInfo);
};
export const exportModelFormExcel = (paramInfo) => {
    return post(constants.API_EXPORT_MODEL_FORM_EXCEL, paramInfo);
};
export const getModelFormInstanceQR = (param) => {
    return get(constants.API_MODEL_FORM_GETMODELFORMINSTANCEQR, param);
};
export const getExcelDataExportId = (paramInfo) => {
    return post(constants.API_EXPORT_MODEL_GET_EXCEL_EXPORTID, paramInfo);
};
export const getExcelCommonDataExportId = (paramInfo) => {
    return post(constants.API_COMMON_EXPORT_MODEL_GET_EXCEL_EXPORTID, paramInfo);
};
export const getModelFormReportList = (params = { currentPage: 1, pageSize: 10 }) => {
    return post(constants.API_MODEL_FORM_REPORTLIST_LIST, params);
};
export const getTableColumnsByFormId = (params = { currentPage: 1, pageSize: 10 }) => {
    return post(constants.API_TABEL_COLUMNS_BY_FORMID, params);
};

export const getFormColumnsByFormId = (params) => {
    return post(constants.API_GET_FORM_COLUMNS_BY_FORMID, params);
};

export const delModelFormInstance = (instatnceId) => {
    return del(constants.API_APPLICATION_MODELFORMINSTATNCE_DELETE, { id: instatnceId });
};

export const getAppAssignList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_APPLICATION_ASSIGN_LIST, params);
};

export const getFormAuthByModelId = (params) => {
    return get(constants.API_FORM_AUTH_BY_MODELID, params);
};

export const getAppUnAssignList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_APPLICATION_UNASSIGN_LIST, params);
};

export const getApplicationModelMenuList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_APPLICATION_MODELMENU_LIST, params);
};
export const getApplicationModelAllMenuList = (params) => {
    return get(constants.API_APPLICATION_MODEL_ALLMENU_LIST, params);
};

export const getApplicationModelTreeList = (params) => {
    return get(constants.API_APPLICATION_MODELTREE_LIST, params);
};

export const getApplicationModelDetail = (modelId) => {
    return get(constants.API_APPLICATION_MODEL_DETAIL.replace(':modelId', modelId));
};

export const syncProcessData = (params) => {
    return post(constants.API_SYNCPROCESSDATA, params);
};

export const getCronjobList = (params) => {
    return get(constants.API_CRONJOB_LIST, params);
};

export const getCronjobDetail = (cronjobId) => {
    return get(constants.API_CRONJOB_DETAIL.replace(':id', cronjobId));
};

export const delCronjob = (cronjobId) => {
    return del(constants.API_CRONJOB_DELETE.replace(':id', cronjobId));
};

export const saveCronjob = (cronjob) => {
    if (cronjob.id === undefined || cronjob.id === '') {
        return post(constants.API_CRONJOB_SAVE, cronjob);
    } else {
        return put(constants.API_CRONJOB_UPDATE, cronjob);
    }
};

export const updCronjob = (cronjob) => {
    return put(constants.API_CRONJOB_UPDATE, cronjob);
};

export const addScheduleStart = (params) => {
    return post(constants.API_CRONJOB_ADDSCHEDULESTART, params);
};

export const addSchedulePause = (params) => {
    return post(constants.API_CRONJOB_ADDSCHEDULEPAUSE, params);
};

export const addScheduleResume = (params) => {
    return post(constants.API_CRONJOB_ADDSCHEDULERESUME, params);
};

export const getApplicationModelUserAuth = (params) => {
    return get(constants.API_APPLICATION_MODEL_USERAUTH, params);
};

export const saveApplicationModelUserAuth = (model) => {
    return post(constants.API_APPLICATION_MODEL_SAVE_USERAUTH, model);
};

export const delApplicationModelUserAuth = (ids, users, formId) => {
    return del(constants.API_APPLICATION_MODEL_DELETE_USERAUTH.replace(':ids', ids).replace(':users', users).replace(':formId', formId));
};

export const getApplicationModelDataAuth = (params) => {
    return get(constants.API_APPLICATION_MODEL_DATAAUTH, params);
};

export const saveApplicationModelDataAuth = (model) => {
    return post(constants.API_APPLICATION_MODEL_SAVE_DATAAUTH, model);
};

export const delApplicationModelDataAuth = (ids) => {
    return del(constants.API_APPLICATION_MODEL_DELETE_DATAAUTH.replace(':ids', ids));
};

// 获取应用介绍
export const getAppDescribeById = (appId) => {
    return get(constants.API_APPLICATION_DESCRIBER.replace(':appId', appId));
};

// 公告管理
export const getNoticeList = (params) => {
    return get(constants.API_NOTICE_LIST, params);
};

export const getMandatoryReminder = (params) => {
    return post(constants.API_GET_MANDATORY_REMINDER, params);
};

export const saveMandatoryReminder = (params) => {
    return post(constants.API_SAVE_MANDATORY_REMINDER, params);
};

export const getNoticeDetail = (id) => {
    return get(constants.API_NOTICET_DETAIL.replace(':id', id));
};

export const saveNotice = (params) => {
    return put(constants.API_NOTICET_SAVE, params);
};

export const deleteNotice = (id) => {
    return del(constants.API_NOTICET_DELETE.replace(':id', id));
};

export const publishNotice = (id) => {
    return post(constants.API_NOTICET_PUBLISHNOTICE.replace(':id', id));
};

export const publishCronjobNotice = (params) => {
    return post(constants.API_NOTICET_PUBLISHCRONJOBNOTICE, params);
};

export const getNoticeReadDetail = (params) => {
    return post(constants.API_NOTICET_GETNOTICEREADDETAIL, params);
};
// 获取当前用户下的所有表单
export const getUserForms = (params) => {
    return get(constants.API_APPLICATION_GET_USER_FORMS, params);
};
// 获取组织结构数据权限结构体
export const getOrgAuthList = (params) => {
    return get(constants.API_APPLICATION_GET_ORG_AUTH_LIST, params);
};
// 批量授权表单数据
export const saveBatchApplicationModelDataAuth = (params) => {
    return post(constants.API_APPLICATION_SAVE_BATCH_MODEL_DATA_AUTH, params);
};

// 报表树结构数据
export const getModelFormReportTree = (params = { currentPage: 1, pageSize: 10 }) => {
    return post(constants.API_MODEL_FORM_REPORT_TREE_GET, params);
};

// 报表Org树结构数据
export const getModelFormReportOrgTree = (formId, dataId) => {
    return get(constants.API_MODEL_FORM_REPORT_ORG_TREE_GET, {formId: formId, dataId: dataId});
};

// 报表主表是否存在流程实例中
export const getProcessInstanceFormCnt = (formId, processInstanceId) => {
    return get(constants.API_PROCESS_INSTANCE_FORM_CNT_GET, {formId: formId, processInstanceId: processInstanceId});
};

// 获取企业模型菜单树
export const getApplicationModelTreeMenu = (param) => {
    return get(constants.API_APPLICATION_MODEL_TREE_MENU, param);
};
// 获取根据类型获取模型列表
export const getModelListByType = (params) => {
    return get(constants.API_MODEL_GET_MODEL_LIST_BY_TYPEE_GET, params);
};

export const updAppIsEnable = (params) => {
    return post(constants.API_DATASTORE_APP_ISENABLE_UPDE, params);
};

export const saveAppCaseInvisibleCompanys = (params) => {
    return post(constants.API_DATASTORE_APP_INVISIBLE_COMPANYS_SAVE, params);
};

// 查询表单附件文件列表
export const getFormFilesList = (params) => {
    return get(constants.API_APPLICATION_GET_FORM_FIELES_LIST, params);
};

// 查询指定表单内的档案字段模板list
export const getArchiveTemplateListByFormId = (params) => {
    return get(constants.API_APPLICATION_GET_ARCHIVE_TEMPLATE_LIST_BY_FORMID, params);
};
// 查询指定标签的对应档案的文件list
export const getArchiveTemplateListByTagId = (params) => {
    return get(constants.API_APPLICATION_GET_ARCHIVE_TEMPLATE_LIST_BY_TAGID, params);
};

/** 获取跨表单字段的值 */
export const getCrossFieldData = (params) => {
    return post(constants.API_APPLICATION_MODEL_FORM_GET_CROSSFIELD_DATA, params);
};

// 查询表单数据修改记录
export const getFormDataUpdRecordBOList = (params) => {
    return get(constants.API_APPLICATION_FORM_DATA_UPD_RECORDBO_LIST, params);
};

// 跨年统计字段值更新
export const updCrossCountFieldData = (params) => {
    return post(constants.API_APPLICATION_CROSS_COUNT_FIELD_DATA_UPD, params);
};
// RPA规则更新数据
export const updRPARuleData = (params) => {
    return post(constants.API_APPLICATION_RPA_GENERATE_DATA, params);
};

export const getCrossCountFieldCnt = (params) => {
    return get(constants.API_APPLICATION_CROSS_COUNT_FIELD_CNT, params);
};

// 智能补全接口
export const getSingleFieldDataList = (params) => {
    return get(constants.API_APPLICATION_SINGLE_FIELD_DATA_LIST, params);
};

export const getPartyBUildingAuthorize = (params) => {
    return post(constants.API_GET_PARTY_BUILDING_AUTHORIZE, params);
};

export const sendMessageToUser = (params) => {
    return post(constants.API_SEND_MESSAGE_TO_USER, params);
};



// WEBPACK FOOTER //
// ./src/data-model/application/application-model.js